import { api } from './api';

export interface PublicUser {
  id: string;
  email: string | null;
  name: string | null;
  pictureUrl: string | null;
  countryCode: string | null;
  primaryLocale: string | null;
  emailVerified: boolean;
  isAdmin?: boolean;
}

export const authApi = {
  /** Returns the current user when the session cookie is valid, or null. */
  async me(): Promise<PublicUser | null> {
    try {
      const r = await api.get<PublicUser>('/api/auth/me');
      return r.data;
    } catch {
      return null;
    }
  },

  async logout(): Promise<void> {
    try {
      await api.post('/api/auth/logout');
    } catch {
      // Ignore — cookie is HttpOnly, the user is already effectively logged out client-side.
    }
  },

  /** Returns the absolute URL the browser should navigate to for Google OAuth. */
  googleStartUrl(): string {
    const base = (import.meta.env.VITE_API_URL as string | undefined) || '';
    return `${base}/auth/google`;
  },
};
